module.exports = __webpack_public_path__ + "img/background_c3-2.2d53526b.jpg";